<template>
	<v-container grid-list-md>
		<v-row>
			<v-col>
				<v-form ref="form">
					<fieldset :disabled="salvando">
						<v-card>
							<v-card-title>
								<slot name="title" :data="data" :carregando="carregando" />
							</v-card-title>
							<v-container fluid class="pa-0">
								<AppLoading v-if="carregando" />
								<v-card-text v-else-if="erro"> {{ erro || 'Não encontrado' }} </v-card-text>
								<template v-else>
									<slot name="content" :data="data">
										<v-card-text>
											<v-container fluid>
												<slot :data="data" />
											</v-container>
										</v-card-text>
									</slot>
								</template>
							</v-container>
							<v-card-actions>
								<v-btn
									color="grey"
									text
									@click="() => $router.go(-1)"
								> Cancelar </v-btn>
								<v-spacer></v-spacer>
								<v-btn
									color="primary"
									@click="salvar"
									:loading="salvando"
								> Salvar </v-btn>
							</v-card-actions>
						</v-card>
					</fieldset>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script setup lang="ts">
import { computed, nextTick, PropType, ref } from 'vue'
import GenericService from '../shareds/GenericService'
import { alert } from '../store'

const props = defineProps({
	service: { type: Object as PropType<GenericService<any, any>>, required: true },
	novo: { type: Boolean, default: false },
	id: { type: String },
	initialExpression: { type: Function as PropType<() => any>, required: true },
	beforeSave: {
		type: Function as PropType<((input: any) => any) | null>, default: null,
	},
	afterLoad: {
		type: Function as PropType<((input: any) => any) | null>, default: null,
	},
})

const emit = defineEmits<{
	(e: 'save', resposta: unknown): void
}>()

const form = ref<HTMLFormElement & {
	validate: (() => boolean),
}>()

const carregando = ref(true)
const erro = ref<string | undefined>(undefined)

const salvando = ref(false)
const versaoAnterior = ref<string | null>(null)
const data = ref(props.initialExpression())

async function carregar() {
	carregando.value = true
	erro.value = undefined
	try {
		const dados = props.novo
			? props.initialExpression()
			: await props.service.get(props.id!)
		data.value = props.afterLoad
			? props.afterLoad(dados)
			: dados
		nextTick().then(() => {
			versaoAnterior.value = JSON.stringify(data.value)
		})
	} catch (error) {
		erro.value = (error as any).message
	} finally {
		carregando.value = false
	}
}

carregar()

async function salvar() {
	if (!form.value!.validate()) {
		console.info("Form inválido")
		return
	}
	salvando.value = true
	try {
		const dataAfterBeforeHook = props.beforeSave
			? await props.beforeSave({...data.value})
			: data.value
		const response = props.novo
			? await props.service.post(dataAfterBeforeHook)
			: await props.service.put(props.id!, dataAfterBeforeHook)
		versaoAnterior.value = JSON.stringify(data.value)
		emit('save', response)
	} catch (error) {
		alert.setError(error)
	} finally {
		salvando.value = false
	}
}

const temAlteracao = computed(() => versaoAnterior.value !== JSON.stringify(data.value))

function validarSaida(): false | void {
	if(!temAlteracao.value) return
	return confirm("Alguns dados não foram salvos. Deseja mesmo sair?") && undefined
}

defineExpose({ data, validarSaida })
</script>
